module.exports = __webpack_public_path__ + "static/media/138847457.af6ad798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AlliedHealth/138847457.jpg
// module id = 635
// module chunks = 0